import React, { useMemo, useState } from 'react';
import { View, Image, Pressable, useWindowDimensions, Platform } from 'react-native';
import { useAnimatedReaction } from 'react-native-reanimated';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

import armorCorrect from '../../assets/images/objects/armor/armorCorrect.png';
import armorDefault from '../../assets/images/objects/armor/armorDefault.png';
import armorExplore from '../../assets/images/objects/armor/armorExplore.png';
import armorQuestion from '../../assets/images/objects/armor/armorQuestion.png';
import armorWrong from '../../assets/images/objects/armor/armorWrong.png';
import bedCorrect from '../../assets/images/objects/bed/bedCorrect.png';
import bedDefault from '../../assets/images/objects/bed/bedDefault.png';
import bedExplore from '../../assets/images/objects/bed/bedExplore.png';
import bedQuestion from '../../assets/images/objects/bed/bedQuestion.png';
import bedWrong from '../../assets/images/objects/bed/bedWrong.png';
import canCorrect from '../../assets/images/objects/can/canCorrect.png';
import canDefault from '../../assets/images/objects/can/canDefault.png';
import canExplore from '../../assets/images/objects/can/canExplore.png';
import canQuestion from '../../assets/images/objects/can/canQuestion.png';
import canWrong from '../../assets/images/objects/can/canWrong.png';
import carCorrect from '../../assets/images/objects/car/carCorrect.png';
import carDefault from '../../assets/images/objects/car/carDefault.png';
import carExplore from '../../assets/images/objects/car/carExplore.png';
import carQuestion from '../../assets/images/objects/car/carQuestion.png';
import carWrong from '../../assets/images/objects/car/carWrong.png';
import chaliceQuestion from '../../assets/images/objects/chalice/chaliceCard.png';
import chaliceCorrect from '../../assets/images/objects/chalice/chaliceCorrect.png';
import chaliceDefault from '../../assets/images/objects/chalice/chaliceDefault.png';
import chaliceExplore from '../../assets/images/objects/chalice/chaliceExplore.png';
import chaliceWrong from '../../assets/images/objects/chalice/chaliceWrong.png';
import dumbbellCorrect from '../../assets/images/objects/dumbbell/dumbbellCorrect.png';
import dumbbellDefault from '../../assets/images/objects/dumbbell/dumbbellDefault.png';
import dumbbellExplore from '../../assets/images/objects/dumbbell/dumbbellExplore.png';
import dumbbellQuestion from '../../assets/images/objects/dumbbell/dumbbellQuestion.png';
import dumbbellWrong from '../../assets/images/objects/dumbbell/dumbbellWrong.png';
import eiffelCorrect from '../../assets/images/objects/eiffel/eiffelCorrect.png';
import eiffelDefault from '../../assets/images/objects/eiffel/eiffelDefault.png';
import eiffelExplore from '../../assets/images/objects/eiffel/eiffelExplore.png';
import eiffelQuestion from '../../assets/images/objects/eiffel/eiffelQuestion.png';
import eiffelWrong from '../../assets/images/objects/eiffel/eiffelWrong.png';
import frameQuestion from '../../assets/images/objects/frame/frameCard.png';
import frameCorrect from '../../assets/images/objects/frame/frameCorrect.png';
import frameDefault from '../../assets/images/objects/frame/frameDefault.png';
import frameExplore from '../../assets/images/objects/frame/frameExplore.png';
import frameWrong from '../../assets/images/objects/frame/frameWrong.png';
import gasCorrect from '../../assets/images/objects/gas/gasCorrect.png';
import gasDefault from '../../assets/images/objects/gas/gasDefault.png';
import gasExplore from '../../assets/images/objects/gas/gasExplore.png';
import gasQuestion from '../../assets/images/objects/gas/gasQuestion.png';
import gasWrong from '../../assets/images/objects/gas/gasWrong.png';
import hotWaterCorrect from '../../assets/images/objects/hotWater/hotWaterCorrect.png';
import hotWaterDefault from '../../assets/images/objects/hotWater/hotWaterDefault.png';
import hotWaterExplore from '../../assets/images/objects/hotWater/hotWaterExplore.png';
import hotWaterQuestion from '../../assets/images/objects/hotWater/hotWaterQuestion.png';
import hotWaterWrong from '../../assets/images/objects/hotWater/hotWaterWrong.png';
import inverterCorrect from '../../assets/images/objects/inverter/inverterCorrect.png';
import inverterDefault from '../../assets/images/objects/inverter/inverterDefault.png';
import inverterExplore from '../../assets/images/objects/inverter/inverterExplore.png';
import inverterQuestion from '../../assets/images/objects/inverter/inverterQuestion.png';
import inverterWrong from '../../assets/images/objects/inverter/inverterWrong.png';
import lipstickCorrect from '../../assets/images/objects/lipstick/lipstickCorrect.png';
import lipstickDefault from '../../assets/images/objects/lipstick/lipstickDefault.png';
import lipstickExplore from '../../assets/images/objects/lipstick/lipstickExplore.png';
import lipstickQuestion from '../../assets/images/objects/lipstick/lipstickQuestion.png';
import lipstickWrong from '../../assets/images/objects/lipstick/lipstickWrong.png';
import medalCorrect from '../../assets/images/objects/medal/medalCorrect.png';
import medalDefault from '../../assets/images/objects/medal/medalDefault.png';
import medalExplore from '../../assets/images/objects/medal/medalExplore.png';
import medalQuestion from '../../assets/images/objects/medal/medalQuestion.png';
import medalWrong from '../../assets/images/objects/medal/medalWrong.png';
import miracleCorrect from '../../assets/images/objects/miracle/miracleCorrect.png';
import miracleDefault from '../../assets/images/objects/miracle/miracleDefault.png';
import miracleExplore from '../../assets/images/objects/miracle/miracleExplore.png';
import miracleQuestion from '../../assets/images/objects/miracle/miracleQuestion.png';
import miracleWrong from '../../assets/images/objects/miracle/miracleWrong.png';
import mirrorCorrect from '../../assets/images/objects/mirror/mirrorCorrect.png';
import mirrorDefault from '../../assets/images/objects/mirror/mirrorDefault.png';
import mirrorExplore from '../../assets/images/objects/mirror/mirrorExplore.png';
import mirrorQuestion from '../../assets/images/objects/mirror/mirrorQuestion.png';
import mirrorWrong from '../../assets/images/objects/mirror/mirrorWrong.png';
import miterCorrect from '../../assets/images/objects/miter/miterCorrect.png';
import miterDefault from '../../assets/images/objects/miter/miterDefault.png';
import miterQuestion from '../../assets/images/objects/miter/miterQuestion.png';
import miterWrong from '../../assets/images/objects/miter/miterWrong.png';
import notebookCorrect from '../../assets/images/objects/notebook/notebookCorrect.png';
import notebookDefault from '../../assets/images/objects/notebook/notebookDefault.png';
import notebookExplore from '../../assets/images/objects/notebook/notebookExplore.png';
import notebookQuestion from '../../assets/images/objects/notebook/notebookQuestion.png';
import notebookWrong from '../../assets/images/objects/notebook/notebookWrong.png';
import paintCanCorrect from '../../assets/images/objects/paintCan/paintCanCorrect.png';
import paintCanDefault from '../../assets/images/objects/paintCan/paintCanDefault.png';
import paintCanExplore from '../../assets/images/objects/paintCan/paintCanExplore.png';
import paintCanQuestion from '../../assets/images/objects/paintCan/paintCanQuestion.png';
import paintCanWrong from '../../assets/images/objects/paintCan/paintCanWrong.png';
import panCorrect from '../../assets/images/objects/pan/panCorrect.png';
import panDefault from '../../assets/images/objects/pan/panDefault.png';
import panExplore from '../../assets/images/objects/pan/panExplore.png';
import panQuestion from '../../assets/images/objects/pan/panQuestion.png';
import panWrong from '../../assets/images/objects/pan/panWrong.png';
import pan2Correct from '../../assets/images/objects/pan2/pan2Correct.png';
import pan2Default from '../../assets/images/objects/pan2/pan2Default.png';
import pan2Explore from '../../assets/images/objects/pan2/pan2Explore.png';
import pan2Question from '../../assets/images/objects/pan2/pan2Question.png';
import pan2Wrong from '../../assets/images/objects/pan2/pan2Wrong.png';
import refrigeratorCorrect from '../../assets/images/objects/refrigerator/refrigeratorCorrect.png';
import refrigeratorDefault from '../../assets/images/objects/refrigerator/refrigeratorDefault.png';
import refrigeratorExplore from '../../assets/images/objects/refrigerator/refrigeratorExplore.png';
import refrigeratorQuestion from '../../assets/images/objects/refrigerator/refrigeratorQuestion.png';
import refrigeratorWrong from '../../assets/images/objects/refrigerator/refrigeratorWrong.png';
import sculptureCorrect from '../../assets/images/objects/sculpture/sculptureCorrect.png';
import sculptureDefault from '../../assets/images/objects/sculpture/sculptureDefault.png';
import sculptureExplore from '../../assets/images/objects/sculpture/sculptureExplore.png';
import sculptureQuestion from '../../assets/images/objects/sculpture/sculptureQuestion.png';
import sculptureWrong from '../../assets/images/objects/sculpture/sculptureWrong.png';
import solarPannelCorrect from '../../assets/images/objects/solarPannel/solarPannelCorrect.png';
import solarPannelDefault from '../../assets/images/objects/solarPannel/solarPannelDefault.png';
import solarPannelExplore from '../../assets/images/objects/solarPannel/solarPannelExplore.png';
import solarPannelQuestion from '../../assets/images/objects/solarPannel/solarPannelQuestion.png';
import solarPannelWrong from '../../assets/images/objects/solarPannel/solarPannelWrong.png';
import streetCorrect from '../../assets/images/objects/street/streetCorrect.png';
import streetDefault from '../../assets/images/objects/street/streetDefault.png';
import streetQuestion from '../../assets/images/objects/street/streetQuestion.png';
import streetWrong from '../../assets/images/objects/street/streetWrong.png';
import supplementCorrect from '../../assets/images/objects/supplement/supplementCorrect.png';
import supplementDefault from '../../assets/images/objects/supplement/supplementDefault.png';
import supplementExplore from '../../assets/images/objects/supplement/supplementExplore.png';
import supplementQuestion from '../../assets/images/objects/supplement/supplementQuestion.png';
import supplementWrong from '../../assets/images/objects/supplement/supplementWrong.png';
import tetrapackCorrect from '../../assets/images/objects/tetrapack/tetrapackCorrect.png';
import tetrapackDefault from '../../assets/images/objects/tetrapack/tetrapackDefault.png';
import tetrapackExplore from '../../assets/images/objects/tetrapack/tetrapackExplore.png';
import tetrapackQuestion from '../../assets/images/objects/tetrapack/tetrapackQuestion.png';
import tetrapackWrong from '../../assets/images/objects/tetrapack/tetrapackWrong.png';
import toiletCorrect from '../../assets/images/objects/toilet/toiletCorrect.png';
import toiletDefault from '../../assets/images/objects/toilet/toiletDefault.png';
import toiletExplore from '../../assets/images/objects/toilet/toiletExplore.png';
import toiletQuestion from '../../assets/images/objects/toilet/toiletQuestion.png';
import toiletWrong from '../../assets/images/objects/toilet/toiletWrong.png';
import trophyCorrect from '../../assets/images/objects/trophy/trophyCorrect.png';
import trophyDefault from '../../assets/images/objects/trophy/trophyDefault.png';
import trophyExplore from '../../assets/images/objects/trophy/trophyExplore.png';
import trophyQuestion from '../../assets/images/objects/trophy/trophyQuestion.png';
import trophyWrong from '../../assets/images/objects/trophy/trophyWrong.png';
import trumpetCorrect from '../../assets/images/objects/trumpet/trumpetCorrect.png';
import trumpetDefault from '../../assets/images/objects/trumpet/trumpetDefault.png';
import trumpetExplore from '../../assets/images/objects/trumpet/trumpetExplore.png';
import trumpetQuestion from '../../assets/images/objects/trumpet/trumpetQuestion.png';
import trumpetWrong from '../../assets/images/objects/trumpet/trumpetWrong.png';
import vaseCorrect from '../../assets/images/objects/vase/vaseCorrect.png';
import vaseDefault from '../../assets/images/objects/vase/vaseDefault.png';
import vaseExplore from '../../assets/images/objects/vase/vaseExplore.png';
import vaseQuestion from '../../assets/images/objects/vase/vaseQuestion.png';
import vaseWrong from '../../assets/images/objects/vase/vaseWrong.png';
import waterFilterCorrect from '../../assets/images/objects/waterFilter/waterFilterCorrect.png';
import waterFilterDefault from '../../assets/images/objects/waterFilter/waterFilterDefault.png';
import waterFilterExplore from '../../assets/images/objects/waterFilter/waterFilterExplore.png';
import waterFilterQuestion from '../../assets/images/objects/waterFilter/waterFilterQuestion.png';
import waterFilterWrong from '../../assets/images/objects/waterFilter/waterFilterWrong.png';
import { getObjectData } from '../../data/gameObjects';
// import { Container } from './styles';

const ObjectsPositioning = ({
  initialValue,
  gameType,
  translateSecondFloorSide,
  handleObjectFound,
  corrects = {},
  errors = {},
}) => {
  const { height } = useWindowDimensions();
  const insets = useSafeAreaInsets();

  const HEIGHT = height - insets.top - insets.bottom;

  const BOTTOM_ZERO_FLOOR = 0.062 * height;
  const BOTTOM_FIRST_FLOOR = 0.062 * height + 0.1638 * HEIGHT + 0.0155 * HEIGHT;
  const BOTTOM_SECOND_FLOOR = 0.062 * height + 0.345845 * HEIGHT;
  const BOTTOM_THIRD_FLOOR =
    0.062 * height + 0.1638 * HEIGHT + 2 * 0.169135 * HEIGHT + 0.013 * HEIGHT;
  const BOTTOM_ROOF_TOP =
    0.062 * height + 0.1638 * HEIGHT + 2 * 0.169135 * HEIGHT + 0.102 * HEIGHT + 0.07878 * HEIGHT;

  const ARMOR_HEIGHT = 0.081 * HEIGHT;
  const BED_HEIGHT = 0.069 * HEIGHT;
  const CAN_HEIGHT = 0.015 * HEIGHT;
  const CAR_HEIGHT = 0.108 * HEIGHT;
  const DUMBBELL_HEIGHT = 0.0132 * HEIGHT;
  const EIFFEL_HEIGHT = 0.029 * HEIGHT;
  const GAS_HEIGHT = 0.0468 * HEIGHT;
  const HOT_WATER_HEIGHT = 0.11484 * HEIGHT;
  const INVERTER_HEIGHT = 0.049 * HEIGHT;
  const LIPSTICK_HEIGHT = 0.013 * HEIGHT;
  const MEDAL_HEIGHT = 0.03359 * HEIGHT;
  const MIRACLE_HEIGHT = 0.045 * HEIGHT;
  const MIRROR_HEIGHT = 0.1101 * HEIGHT;
  const MITER_HEIGHT = 0.13 * HEIGHT;
  const NOTEBOOK_HEIGHT = 0.019 * HEIGHT;
  const PAINT_CAN_HEIGHT = 0.0234 * HEIGHT;
  const PAN_HEIGHT = 0.042 * HEIGHT;
  const PAN2_HEIGHT = 0.021 * HEIGHT;
  const REFRIGERATOR_HEIGHT = 0.113 * HEIGHT;
  const SCULPTURE_HEIGHT = 0.026 * HEIGHT;
  const SOLAR_PANEL_HEIGHT = 0.06 * HEIGHT;
  const STREET_HEIGHT = 0.0585 * HEIGHT;
  const SUPPLEMENT_HEIGHT = 0.0105 * HEIGHT;
  const TETRA_PACK_HEIGHT = 0.0257 * HEIGHT;
  const TOILET_HEIGHT = 0.0625 * HEIGHT;
  const TROPHY_HEIGHT = 0.031 * HEIGHT;
  const TRUMPET_HEIGHT = 0.031 * HEIGHT;
  const VASE_HEIGHT = 0.072 * HEIGHT;
  const CHALICE_HEIGHT = 0.015 * HEIGHT;
  const FRAME_HEIGHT = 0.028 * HEIGHT;
  const WATER_FILTER_HEIGHT = 0.044 * HEIGHT;

  const armorSource = useMemo(() => {
    if (gameType === 'explore') {
      return armorExplore;
    } else {
      if (corrects.armor) {
        return armorCorrect;
      }
      if (errors.armor) {
        return armorWrong;
      }
      return armorDefault;
    }
  }, [corrects.armor, errors.armor, gameType]);
  const chaliceSource = useMemo(() => {
    if (gameType === 'explore') {
      return chaliceExplore;
    } else {
      if (corrects.chalice) {
        return chaliceCorrect;
      }
      if (errors.chalice) {
        return chaliceWrong;
      }
      return chaliceDefault;
    }
  }, [corrects.chalice, errors.chalice, gameType]);
  const frameSource = useMemo(() => {
    if (gameType === 'explore') {
      return frameExplore;
    } else {
      if (corrects.frame) {
        return frameCorrect;
      }
      if (errors.frame) {
        return frameWrong;
      }
      return frameDefault;
    }
  }, [corrects.frame, errors.frame, gameType]);

  const bedSource = useMemo(() => {
    if (gameType === 'explore') {
      return bedExplore;
    } else {
      if (corrects.bed) {
        return bedCorrect;
      }
      if (errors.bed) {
        return bedWrong;
      }
      return bedDefault;
    }
  }, [corrects.bed, errors.bed, gameType]);

  const canSource = useMemo(() => {
    if (gameType === 'explore') {
      return canExplore;
    } else {
      if (corrects.can) {
        return canCorrect;
      }
      if (errors.can) {
        return canWrong;
      }
      return canDefault;
    }
  }, [corrects.can, errors.can, gameType]);

  const carSource = useMemo(() => {
    if (gameType === 'explore') {
      return carExplore;
    } else {
      if (corrects.car) {
        return carCorrect;
      }
      if (errors.car) {
        return carWrong;
      }
      return carDefault;
    }
  }, [corrects.car, errors.car, gameType]);

  const dumbbellSource = useMemo(() => {
    if (gameType === 'explore') {
      return dumbbellExplore;
    } else {
      if (corrects.dumbbell) {
        return dumbbellCorrect;
      }
      if (errors.dumbbell) {
        return dumbbellWrong;
      }
      return dumbbellDefault;
    }
  }, [corrects.dumbbell, errors.dumbbell, gameType]);

  const eiffelSource = useMemo(() => {
    if (gameType === 'explore') {
      return eiffelExplore;
    } else {
      if (corrects.eiffel) {
        return eiffelCorrect;
      }
      if (errors.eiffel) {
        return eiffelWrong;
      }
      return eiffelDefault;
    }
  }, [corrects.eiffel, errors.eiffel, gameType]);

  const gasSource = useMemo(() => {
    if (gameType === 'explore') {
      return gasExplore;
    } else {
      if (corrects.gas) {
        return gasCorrect;
      }
      if (errors.gas) {
        return gasWrong;
      }
      return gasDefault;
    }
  }, [corrects.gas, errors.gas, gameType]);

  const hotWaterSource = useMemo(() => {
    if (gameType === 'explore') {
      return hotWaterExplore;
    } else {
      if (corrects.hotWater) {
        return hotWaterCorrect;
      }
      if (errors.hotWater) {
        return hotWaterWrong;
      }
      return hotWaterDefault;
    }
  }, [corrects.hotWater, errors.hotWater, gameType]);

  const inverterSource = useMemo(() => {
    if (gameType === 'explore') {
      return inverterExplore;
    } else {
      if (corrects.inverter) {
        return inverterCorrect;
      }
      if (errors.inverter) {
        return inverterWrong;
      }
      return inverterDefault;
    }
  }, [corrects.inverter, errors.inverter, gameType]);

  const lipstickSource = useMemo(() => {
    if (gameType === 'explore') {
      return lipstickExplore;
    } else {
      if (corrects.lipstick) {
        return lipstickCorrect;
      }
      if (errors.lipstick) {
        return lipstickWrong;
      }
      return lipstickDefault;
    }
  }, [corrects.lipstick, errors.lipstick, gameType]);

  const medalSource = useMemo(() => {
    if (gameType === 'explore') {
      return medalExplore;
    } else {
      if (corrects.medal) {
        return medalCorrect;
      }
      if (errors.medal) {
        return medalWrong;
      }
      return medalDefault;
    }
  }, [corrects.medal, errors.medal, gameType]);

  const miracleSource = useMemo(() => {
    if (gameType === 'explore') {
      return miracleExplore;
    } else {
      if (corrects.miracle) {
        return miracleCorrect;
      }
      if (errors.miracle) {
        return miracleWrong;
      }
      return miracleDefault;
    }
  }, [corrects.miracle, errors.miracle, gameType]);

  const mirrorSource = useMemo(() => {
    if (gameType === 'explore') {
      return mirrorExplore;
    } else {
      if (corrects.mirror) {
        return mirrorCorrect;
      }
      if (errors.mirror) {
        return mirrorWrong;
      }
      return mirrorDefault;
    }
  }, [corrects.mirror, errors.mirror, gameType]);

  const mitterSource = useMemo(() => {
    if (corrects.mitter) {
      return miterCorrect;
    }
    if (errors.mitter) {
      return miterWrong;
    }
    return miterDefault;
  }, [corrects.mitter, errors.mitter]);

  const notebookSource = useMemo(() => {
    if (gameType === 'explore') {
      return notebookExplore;
    } else {
      if (corrects.notebook) {
        return notebookCorrect;
      }
      if (errors.notebook) {
        return notebookWrong;
      }
      return notebookDefault;
    }
  }, [corrects.notebook, errors.notebook, gameType]);

  const paintCanSource = useMemo(() => {
    if (gameType === 'explore') {
      return paintCanExplore;
    } else {
      if (corrects.paintCan) {
        return paintCanCorrect;
      }
      if (errors.paintCan) {
        return paintCanWrong;
      }
      return paintCanDefault;
    }
  }, [corrects.paintCan, errors.paintCan, gameType]);

  const panSource = useMemo(() => {
    if (gameType === 'explore') {
      return panExplore;
    } else {
      if (corrects.pan) {
        return panCorrect;
      }
      if (errors.pan) {
        return panWrong;
      }
      return panDefault;
    }
  }, [corrects.pan, errors.pan, gameType]);

  const pan2Source = useMemo(() => {
    if (gameType === 'explore') {
      return pan2Explore;
    } else {
      if (corrects.pan2) {
        return pan2Correct;
      }
      if (errors.pan2) {
        return pan2Wrong;
      }
      return pan2Default;
    }
  }, [corrects.pan2, errors.pan2, gameType]);

  const refrigeratorSource = useMemo(() => {
    if (gameType === 'explore') {
      return refrigeratorExplore;
    } else {
      if (corrects.refrigerator) {
        return refrigeratorCorrect;
      }
      if (errors.refrigerator) {
        return refrigeratorWrong;
      }
      return refrigeratorDefault;
    }
  }, [corrects.refrigerator, errors.refrigerator, gameType]);

  const sculptureSource = useMemo(() => {
    if (gameType === 'explore') {
      return sculptureExplore;
    } else {
      if (corrects.sculpture) {
        return sculptureCorrect;
      }
      if (errors.sculpture) {
        return sculptureWrong;
      }
      return sculptureDefault;
    }
  }, [corrects.sculpture, errors.sculpture, gameType]);

  const solarPannelSource = useMemo(() => {
    if (gameType === 'explore') {
      return solarPannelExplore;
    } else {
      if (corrects.solarPannel) {
        return solarPannelCorrect;
      }
      if (errors.solarPannel) {
        return solarPannelWrong;
      }
      return solarPannelDefault;
    }
  }, [corrects.solarPannel, errors.solarPannel, gameType]);

  const streetSource = useMemo(() => {
    if (corrects.street) {
      return streetCorrect;
    }
    if (errors.street) {
      return streetWrong;
    }
    return streetDefault;
  }, [corrects.street, errors.street]);

  const supplementSource = useMemo(() => {
    if (gameType === 'explore') {
      return supplementExplore;
    } else {
      if (corrects.supplement) {
        return supplementCorrect;
      }
      if (errors.supplement) {
        return supplementWrong;
      }
      return supplementDefault;
    }
  }, [corrects.supplement, errors.supplement, gameType]);

  const tetrapackSource = useMemo(() => {
    if (gameType === 'explore') {
      return tetrapackExplore;
    } else {
      if (corrects.tetrapack) {
        return tetrapackCorrect;
      }
      if (errors.tetrapack) {
        return tetrapackWrong;
      }
      return tetrapackDefault;
    }
  }, [corrects.tetrapack, errors.tetrapack, gameType]);

  const toiletSource = useMemo(() => {
    if (gameType === 'explore') {
      return toiletExplore;
    } else {
      if (corrects.toilet) {
        return toiletCorrect;
      }
      if (errors.toilet) {
        return toiletWrong;
      }
      return toiletDefault;
    }
  }, [corrects.toilet, errors.toilet, gameType]);

  const trophySource = useMemo(() => {
    if (gameType === 'explore') {
      return trophyExplore;
    } else {
      if (corrects.trophy) {
        return trophyCorrect;
      }
      if (errors.trophy) {
        return trophyWrong;
      }
      return trophyDefault;
    }
  }, [corrects.trophy, errors.trophy, gameType]);

  const trumpetSource = useMemo(() => {
    if (gameType === 'explore') {
      return trumpetExplore;
    } else {
      if (corrects.trumpet) {
        return trumpetCorrect;
      }
      if (errors.trumpet) {
        return trumpetWrong;
      }
      return trumpetDefault;
    }
  }, [corrects.trumpet, errors.trumpet, gameType]);

  const vaseSource = useMemo(() => {
    if (gameType === 'explore') {
      return vaseExplore;
    } else {
      if (corrects.vase) {
        return vaseCorrect;
      }
      if (errors.vase) {
        return vaseWrong;
      }
      return vaseDefault;
    }
  }, [corrects.vase, errors.vase, gameType]);

  const waterFilterSource = useMemo(() => {
    if (gameType === 'explore') {
      return waterFilterExplore;
    } else {
      if (corrects.waterFilter) {
        return waterFilterCorrect;
      }
      if (errors.waterFilter) {
        return waterFilterWrong;
      }
      return waterFilterDefault;
    }
  }, [corrects.waterFilter, errors.waterFilter, gameType]);

  const [renderMitter, setRenderMitter] = useState(true);

  // Helper function to create object data
  const createObjectData = (objectId) => {
    const objectData = getObjectData(objectId);
    if (!objectData) return null;

    return {
      asset: objectData.asset,
      title: objectData.title,
      object: objectData.id,
      explorationText: objectData.explorationText,
      question: objectData.question,
      answers: objectData.answers,
    };
  };

  const imageStyle = useMemo(() => {
    return {
      height: '100%',
      width: '100%',
      shadowOffset: {
        width: 0,
        height: 0,
      },

      shadowOpacity: gameType === 'explore' ? 1 : 0,
      shadowRadius: gameType === 'explore' ? 2 : 0,
      shadowColor: 'white',
    };
  }, [gameType]);

  useAnimatedReaction(
    () => {
      return translateSecondFloorSide.value;
    },
    (result) => {
      if (result === initialValue) {
        setRenderMitter(true);
      } else {
        setRenderMitter(false);
      }
    },
    [translateSecondFloorSide]
  );

  return (
    <>
      <Pressable
        style={{
          height: ARMOR_HEIGHT,
          width: 0.23 * ARMOR_HEIGHT,

          alignSelf: 'center',
          position: 'absolute',
          bottom: BOTTOM_FIRST_FLOOR,
          transform: [{ translateX: 0.1532 * HEIGHT }],
        }}
        onPress={() => {
          const objectData = createObjectData('armor');
          if (objectData) {
            handleObjectFound(objectData);
          }
        }}>
        <Image source={armorSource} style={imageStyle} />
      </Pressable>

      <Pressable
        style={{
          height: BED_HEIGHT,
          width: 2.16292135 * BED_HEIGHT,
          alignSelf: 'center',
          explorationText:
            'Durante o século XIX o ferro foi utilizado no desenvolvimento de diversos segmentos como na indústria fabril, onde era empregado na produção de máquinas, na arquitetura, no desenvolvimento das ferrovias, entre outros. Também era comum na fabricação de mobiliários e na decoração.',
          position: 'absolute',
          bottom: BOTTOM_THIRD_FLOOR,
          transform: [{ translateX: 0.108 * HEIGHT }],
        }}
        onPress={() => {
          handleObjectFound({
            asset: bedQuestion,
            title: 'Cama',
            object: 'bed',
            explorationText:
              'Durante o século XIX o ferro foi utilizado no desenvolvimento de diversos segmentos como na indústria fabril, onde era empregado na produção de máquinas, na arquitetura, no desenvolvimento das ferrovias, entre outros. Também era comum na fabricação de mobiliários e na decoração.',
            question:
              'Durante o século XIX, esse metal foi pioneiro no desenvolvimento de diversos segmentos como na indústria fabril, onde era empregado na produção de máquinas, na arquitetura, no desenvolvimento das ferrovias, entre outros. Também era comum na fabricação de mobiliários e na decoração. Qual é o metal?',
            answers: [
              { letter: 'A.', text: 'Latão', correct: false },
              { letter: 'B.', text: 'Cobre', correct: false },
              { letter: 'C.', text: 'Ferro', correct: true },
              { letter: 'D.', text: 'Manganês', correct: false },
            ],
          });
        }}>
        <Image source={bedSource} style={imageStyle} />
      </Pressable>

      <Pressable
        style={{
          height: CAN_HEIGHT,
          width: 1.07157895 * CAN_HEIGHT,
          alignSelf: 'center',
          position: 'absolute',

          bottom: BOTTOM_ZERO_FLOOR + 0.0415 * HEIGHT,
          transform: [{ translateX: -0.046 * HEIGHT }, { scale: 2 }],
        }}
        onPress={() => {
          handleObjectFound({
            asset: canQuestion,
            title: 'Latinha',
            object: 'can',
            explorationText:
              'O Alumínio é um dos metais mais utilizados na indústria de embalagens por ser leve, resistente e por conservar os produtos, pois os protege da ação da luz e da umidade e do ar.',
            question:
              'Que metal é um dos mais utilizados na indústria de embalagens por ser leve, resistente e por conservar os produtos, pois os protege da ação da luz, da umidade e do ar? Também é reconhecido por seu potencial de sustentabilidade, já que é infinitamente reciclável.',
            answers: [
              { letter: 'A.', text: 'Alumínio', correct: true },
              { letter: 'B.', text: 'Chumbo', correct: false },
              { letter: 'C.', text: 'Papelão', correct: false },
              { letter: 'D.', text: 'Ferro', correct: false },
            ],
          });
        }}>
        <Image source={canSource} style={[imageStyle, { transform: [{ scale: 0.5 }] }]} />
      </Pressable>

      <Pressable
        style={{
          height: CAR_HEIGHT,
          width: 1.9784 * CAR_HEIGHT,
          alignSelf: 'center',
          position: 'absolute',
          bottom: BOTTOM_ZERO_FLOOR - 0.04 * HEIGHT,
          transform: [{ translateX: 0.17 * HEIGHT }],
          zIndex: 2,
        }}
        onPress={() => {
          handleObjectFound({
            asset: carQuestion,
            title: 'Bateria de carro',
            object: 'car',
            explorationText:
              'O Brasil possui a maior reserva de nióbio do mundo, cerca de 94% das jazidas. A sua aplicação mais comum ocorre na indústria siderúrgica, pois ele é capaz de conferir algumas propriedades específicas ao aço, como soldabilidade, tenacidade e conformabilidade, além de maior resistência. Desse modo, é utilizado na indústria do aço, nos chamados aços microligados. Este tipo de aço é utilizado na construção de oleodutos e gasodutos e plataformas para exploração de petróleo e na construção naval. Além disso, pode ser utilizado na indústria automobilística, conferindo alta resistência mecânica, utilizados em chassis de caminhões, rodas de veículos e na fabricação de automóveis.',
            question:
              'O Brasil possui 94% das jazidas mundiais deste metal cuja maior aplicação é na indústria siderúrgica para criar os aços microligados. A adição deste metal a liga de aço confere mais soldabilidade, tenacidade, conformidade e resistência ao mesmo. No nosso dia a dia podemos encontrá-los em chassis de caminhões, rodas de veículos e na fabricação de automóveis. Que metal é esse?',
            answers: [
              { letter: 'A.', text: 'Estanho', correct: false },
              { letter: 'B.', text: 'Nióbio', correct: true },
              { letter: 'C.', text: 'Prata', correct: false },
              { letter: 'D.', text: 'Ferro', correct: false },
            ],
          });
        }}>
        <Image source={carSource} style={imageStyle} />
      </Pressable>

      <Pressable
        style={{
          height: DUMBBELL_HEIGHT,
          width: 2 * DUMBBELL_HEIGHT,
          alignSelf: 'center',
          position: 'absolute',
          bottom: BOTTOM_THIRD_FLOOR + 0.07878 * HEIGHT,
          transform: [{ translateX: -0.134 * HEIGHT }],
        }}
        onPress={() => {
          handleObjectFound({
            asset: dumbbellQuestion,
            title: 'Peso',
            object: 'dumbbell',
            explorationText:
              'O chumbo integra o grupo dos metais pesados. Possui muitas aplicações, entre elas é comum em pesos de academia.',
            question: 'Qual metal é conhecido por ser utilizado em pesos de academia?',
            answers: [
              { letter: 'A.', text: 'Zinco', correct: false },
              { letter: 'B.', text: 'Chumbo', correct: true },
              { letter: 'C.', text: 'Ouro', correct: false },
              { letter: 'D.', text: 'Cobre', correct: false },
            ],
          });
        }}>
        <Image source={dumbbellSource} style={imageStyle} />
      </Pressable>

      <Pressable
        style={{
          height: EIFFEL_HEIGHT,
          width: 0.56410256 * EIFFEL_HEIGHT,
          alignSelf: 'center',
          position: 'absolute',
          bottom: BOTTOM_THIRD_FLOOR + 0.082 * HEIGHT,
          transform: [{ translateX: -0.1 * HEIGHT }],
        }}
        onPress={() => {
          handleObjectFound({
            asset: eiffelQuestion,
            title: 'Souvenir',
            object: 'eiffel',
            explorationText:
              'A Torre Eiffel é uma estrutura de ferro produzida para a Exposição universal de 1889. Muito criticada por artistas e intelectuais daquela época, hoje é uma das obras mais reconhecidas do mundo.',
            question:
              'A Torre Eiffel foi produzida para a Exposição universal de 1889. Muito criticada por artistas e intelectuais daquela época, hoje é uma das obras mais reconhecidas do mundo. Qual é o metal de sua estrutura?',
            answers: [
              { letter: 'A.', text: 'Ferro', correct: true },
              { letter: 'B.', text: 'Chumbo', correct: false },
              { letter: 'C.', text: 'Aço', correct: false },
              { letter: 'D.', text: 'Estanho', correct: false },
            ],
          });
        }}>
        <Image source={eiffelSource} style={imageStyle} />
      </Pressable>

      <Pressable
        style={{
          height: GAS_HEIGHT,
          width: 0.75 * GAS_HEIGHT,
          alignSelf: 'center',
          position: 'absolute',
          bottom: BOTTOM_SECOND_FLOOR,
          transform: [{ translateX: 0.069 * HEIGHT }],
        }}
        onPress={() => {
          handleObjectFound({
            asset: gasQuestion,
            title: 'Botijão de gás',
            explorationText:
              'O aço também é utilizado na fabricação de botijões de gás. Neste caso a redução do peso, economia da manutenção, resistência à corrosão e um maior ciclo de vida do metal foram os fatores cruciais para que o metal seja empregado na fabricação.',
            object: 'gas',
            question:
              'Para reduzir o peso, aumentar a resistência à corrosão e trazer mais economia com pintura e manutenção, os botijões de gás são geralmente fabricados com qual liga metálica?',
            answers: [
              { letter: 'A.', text: 'Ouro', correct: false },
              { letter: 'B.', text: 'Estanho', correct: false },
              { letter: 'C.', text: 'Aço', correct: true },
              { letter: 'D.', text: 'Prata', correct: false },
            ],
          });
        }}>
        <Image source={gasSource} style={imageStyle} />
      </Pressable>

      <Pressable
        style={{
          height: HOT_WATER_HEIGHT,
          width: 1.2244 * HOT_WATER_HEIGHT,
          alignSelf: 'center',
          position: 'absolute',
          bottom: BOTTOM_ROOF_TOP,
          transform: [{ translateX: 0.0422 * HEIGHT }],
        }}
        onPress={() => {
          handleObjectFound({
            asset: hotWaterQuestion,
            title: 'Aquecedor solar',
            explorationText:
              'O aço é uma liga de Ferro e carbono e veio a substituir o Ferro puro em muitas aplicações devido à sua ampla resistência. Sua utilização vai muito além de objetos do dia a dia, sendo empregado também em indústrias pesadas sendo encontrado em geradores, turbinas, estufas e painéis solares.',
            object: 'hotWater',
            question:
              'O setor de energia requer materiais muito resistentes e duráveis. Para isto o ________,uma importante liga com ferro, é essencial para fabricação de motores e geradores usados para a produção de energia eólica, turbinas a vapor e gás. Também é usado de base para construção de placas solares, entre outros',
            answers: [
              { letter: 'A.', text: 'Latão', correct: false },
              { letter: 'B.', text: 'Estanho', correct: false },
              { letter: 'C.', text: 'Aço', correct: true },
              { letter: 'D.', text: 'Chumbo', correct: false },
            ],
          });
        }}>
        <Image source={hotWaterSource} style={imageStyle} />
      </Pressable>

      <Pressable
        style={{
          height: INVERTER_HEIGHT,
          width: 0.3968254 * INVERTER_HEIGHT,
          alignSelf: 'center',
          position: 'absolute',
          bottom: BOTTOM_ROOF_TOP,
          transform: [{ translateX: -0.112 * HEIGHT }],
        }}
        onPress={() => {
          handleObjectFound({
            asset: inverterQuestion,
            title: 'Inversor',
            object: 'inverter',
            explorationText:
              'Ser condutor de eletricidade é uma característica comum dos metais. O cobre é bastante reconhecido por essa propriedade sendo empregado, frequentemente, no setor elétrico e de energia, como na produção das fiações e cabeamentos que utilizamos.',
            question:
              'Diversos metais conduzem eletricidade porém o ____________ apresenta um bom custo/benefício sendo o metal de escolha na produção de fios, cabos e conectores. Além da boa condutividade elétrica também possui boa condutividade térmica tendo aplicações em sistemas de ar e refrigeração.',
            answers: [
              { letter: 'A.', text: 'Ouro', correct: false },
              { letter: 'B.', text: 'Cobre', correct: true },
              { letter: 'C.', text: 'Chumbo', correct: false },
              { letter: 'D.', text: 'Prata', correct: false },
            ],
          });
        }}>
        <Image source={inverterSource} style={imageStyle} />
      </Pressable>

      <Pressable
        style={{
          height: LIPSTICK_HEIGHT,
          width: LIPSTICK_HEIGHT,
          alignSelf: 'center',

          position: 'absolute',
          bottom: BOTTOM_FIRST_FLOOR + 0.041 * HEIGHT,
          transform: [{ translateX: 0.035 * HEIGHT }, { scale: 2 }],
        }}
        onPress={() => {
          handleObjectFound({
            asset: lipstickQuestion,
            title: 'Batom',
            object: 'lipstick',
            explorationText:
              'O chumbo é utilizado na fabricação de tintas e outros pigmentos. No Egito antigo era empregado na produção de maquiagens e tinturas. Hoje, esse metal continua sendo utilizado na indústria cosmética, contudo em concentrações controladas, com grande rigor, e em doses baixas devido a sua toxicidade.',
            question:
              'O metal __________ é utilizado na fabricação de tintas e outros pigmentos. Era utilizado no Egito antigo para produção de maquiagens e tinturas. Hoje, esse metal continua sendo utilizado na indústria cosmética, contudo em concentrações controladas, com grande rigor, e em doses baixas devido a sua toxicidade.',
            answers: [
              { letter: 'A.', text: 'Níquel', correct: false },
              { letter: 'B.', text: 'Ferro', correct: false },
              { letter: 'C.', text: 'Chumbo', correct: true },
              { letter: 'D.', text: 'Cálcio', correct: false },
            ],
          });
        }}>
        <Image source={lipstickSource} style={[imageStyle, { transform: [{ scale: 0.5 }] }]} />
      </Pressable>

      <Pressable
        style={{
          height: MEDAL_HEIGHT,
          width: 1.232558 * MEDAL_HEIGHT,
          alignSelf: 'center',
          position: 'absolute',

          bottom: BOTTOM_THIRD_FLOOR + 0.066 * HEIGHT,
          transform: [{ translateX: 0.061 * HEIGHT }, { scale: 1.4 }],
        }}
        onPress={() => {
          handleObjectFound({
            asset: medalQuestion,
            title: 'Medalha',
            explorationText:
              'As medalhas vieram a substituir a tradicinal coroa de louros utilizada em competições na antiguidade. Atualmente, o ouro, a prata e o bronze são  os metais utilizados para a confecção de medalhas  distribuídas  aos três primeiros colocados.',
            object: 'medal',
            question:
              'Na Antiguidade, os atletas vitoriosos nos Jogos Olímpicos recebiam uma coroa de louros, como símbolo da vitória. Atualmente, os vencedores recebem medalhas como parte da premiação. Quais são os três metais que constituem as medalhas olímpicas?',
            answers: [
              { letter: 'A.', text: 'Ouro, Ouro Branco, Ouro Rosê', correct: false },
              { letter: 'B.', text: 'Ouro, Níquel, Latão', correct: false },
              { letter: 'C.', text: 'Ouro, Prata, Bronze', correct: true },
              { letter: 'D.', text: 'Alumínio, Ferro, Cobre', correct: false },
            ],
          });
        }}>
        <Image source={medalSource} style={[imageStyle, { transform: [{ scale: 0.6 }] }]} />
      </Pressable>

      <Pressable
        style={{
          height: MIRACLE_HEIGHT,
          width: 0.685 * MIRACLE_HEIGHT,
          alignSelf: 'center',
          position: 'absolute',
          bottom: BOTTOM_SECOND_FLOOR + 0.091 * HEIGHT,
          transform: [{ translateX: 0.195 * HEIGHT }],
        }}
        onPress={() => {
          handleObjectFound({
            asset: miracleQuestion,
            title: 'Milagro',
            explorationText:
              'O estanho é usado para a produção de embalagens, como de alguns enlatados. É utilizado para a produção da chamada  folha de flandres. Por ser um metal extremamente maleável é utilizado também por artistas e artesãos. No México esse metal é frequentemente utilizado na produção dos chamados milagros, elemento da tradição artesanal e da cultura mexicana.',
            object: 'miracle',
            question:
              'Esse metal é usado para a produção de embalagens, como de alguns enlatados. É utilizado para a produção da chamada  folha de flandres, bastante empregada na indústria de embalagens. É um metal extremamente maleável por isso é utilizado por artistas e artesãos. No México esse metal é frequentemente utilizado na produção dos chamados milagros, elemento da tradição artesanal e da cultura mexicana.',
            answers: [
              { letter: 'A.', text: 'Cobalto', correct: false },
              { letter: 'B.', text: 'Cobre', correct: false },
              { letter: 'C.', text: 'Nióbio', correct: false },
              { letter: 'D.', text: 'Estanho', correct: true },
            ],
          });
        }}>
        <Image source={miracleSource} style={imageStyle} />
      </Pressable>

      <Pressable
        style={{
          height: MIRROR_HEIGHT,
          width: 0.3191489 * MIRROR_HEIGHT,
          alignSelf: 'center',
          position: 'absolute',
          bottom: BOTTOM_THIRD_FLOOR - 1,
          transform: [{ translateX: -0.051 * HEIGHT }],
        }}
        onPress={() => {
          handleObjectFound({
            asset: mirrorQuestion,
            title: 'Espelho',
            object: 'mirror',
            explorationText:
              'Espelhos são feitos de vidro e uma fina camada de prata responsável por refletir as imagens. Este mesmo princípio de reflexão é usado em algumas janelas de edifícios onde uma fina camada de prata ajuda a refletir a luz e manter a temperatura interna do edifício.',
            question:
              'Espelhos assim como algumas janelas de edifícios são revestidos com uma fina camada de metal para refletir luz. No caso das janelas o metal também ajuda a manter o ambiente interno fresco. Que metal seria este?',
            answers: [
              { letter: 'A.', text: 'Nióbio', correct: false },
              { letter: 'B.', text: 'Prata', correct: true },
              { letter: 'C.', text: 'Ouro', correct: false },
              { letter: 'D.', text: 'Estanho', correct: false },
            ],
          });
        }}>
        <Image source={mirrorSource} style={imageStyle} />
      </Pressable>

      {renderMitter && (
        <Pressable
          style={{
            height: MITER_HEIGHT,
            width: 0.53613025 * MITER_HEIGHT,
            alignSelf: 'center',
            position: 'absolute',

            bottom: BOTTOM_SECOND_FLOOR + 0.0001 * HEIGHT,
            transform: [{ translateX: 0.229 * HEIGHT }],
            zIndex: 2,
          }}
          onPress={() => {
            handleObjectFound({
              asset: miterQuestion,
              title: 'Esquadria',
              object: 'mitter',
              explorationText:
                'O Alumínio é um material bastante empregado em esquadrias, portas e janelas por ser leve e resistente à corrosão. O alumínio é uma opção que exige pouca manutenção se comparado aos outros materiais, como madeira, por exemplo.',
              question:
                'Qual metal é bastante empregado na produção de esquadrias de portas e janelas por ser leve e resistente à corrosão? As esquadrias fabricadas com esse metal exigem pouca manutenção se comparadas àquelas fabricadas com outros materiais, como madeira, por exemplo. São adequadas para ambientes com umidade como regiões litorâneas e proporcionam grande durabilidade. ',
              answers: [
                { letter: 'A.', text: 'Ouro', correct: false },
                { letter: 'B.', text: 'Prata', correct: false },
                { letter: 'C.', text: 'Chumbo', correct: false },
                { letter: 'D.', text: 'Alumínio', correct: true },
              ],
            });
          }}>
          <Image source={mitterSource} style={imageStyle} />
        </Pressable>
      )}

      <Pressable
        style={{
          height: NOTEBOOK_HEIGHT,
          width: 1.95833333 * NOTEBOOK_HEIGHT,
          alignSelf: 'center',
          position: 'absolute',
          bottom: BOTTOM_THIRD_FLOOR + 0.0444 * HEIGHT,
          transform: [{ translateX: 0.2021 * HEIGHT }],
        }}
        onPress={() => {
          handleObjectFound({
            asset: notebookQuestion,
            title: 'Notebook',
            object: 'notebook',
            explorationText:
              'A indústria eletrônica e microeletrônica utiliza silício, um material muito abundante na terra como material básico para a produção de transistores, para chips. Nos Estados Unidos, a região que concentra um grande número de empresas de tecnologia ficou conhecida com o nome deste metal, o vale do silício',
            question:
              'A indústria eletrônica e microeletrônica utiliza um material muito abundante na terra como material básico para a produção de transistores para chips. Nos Estados Unidos, a região que concentra um grande número de empresas de tecnologia ficou conhecida com o nome deste metal.',
            answers: [
              { letter: 'A.', text: 'Prata', correct: false },
              { letter: 'B.', text: 'Cobre', correct: false },
              { letter: 'C.', text: 'Silicio', correct: true },
              { letter: 'D.', text: 'Mercúrio', correct: false },
            ],
          });
        }}>
        <Image source={notebookSource} style={imageStyle} />
      </Pressable>

      <Pressable
        style={{
          height: PAINT_CAN_HEIGHT,
          width: 0.98333333 * PAINT_CAN_HEIGHT,
          alignSelf: 'center',
          position: 'absolute',
          bottom: BOTTOM_FIRST_FLOOR,
          transform: [{ translateX: -0.039 * HEIGHT }],
        }}
        onPress={() => {
          handleObjectFound({
            asset: paintCanQuestion,
            title: 'Lata de tinta',
            object: 'paintCan',
            explorationText:
              'Tintas usam diversos materiais orgânicos e inorgânicos (minerais) para criar cores variadas. Por exemplo, o Óxido de Ferro para produzir vermelhos ou o Dióxido de Titânio para produzir brancos.',
            question:
              'Tintas usam diversos materiais orgânicos e inorgânicos (minerais) para criar cores variadas. Óxido de Ferro para produzir vermelhos ou o Dióxido de Titânio para produzir qual cor de tinta?',
            answers: [
              { letter: 'A.', text: 'Verde', correct: false },
              { letter: 'B.', text: 'Vermelho', correct: false },
              { letter: 'C.', text: 'Preta', correct: false },
              { letter: 'D.', text: 'Branca', correct: true },
            ],
          });
        }}>
        <Image source={paintCanSource} style={imageStyle} />
      </Pressable>

      <Pressable
        style={{
          height: PAN_HEIGHT,
          width: 0.56035088 * PAN_HEIGHT,
          alignSelf: 'center',
          position: 'absolute',
          bottom: BOTTOM_SECOND_FLOOR + 0.0575 * HEIGHT,
          transform: [{ translateX: -0.1475 * HEIGHT }],
        }}
        onPress={() => {
          handleObjectFound({
            asset: panQuestion,
            title: 'Frigideira',
            object: 'pan',
            explorationText:
              'As panelas e tachos de cobre são famosos na cozinha e doçaria tradicional brasileira, assim como para a produção de cachaça em alambiques tradicionais.',
            question:
              'As panelas e tachos constituídos por esse metal são famosos na cozinha e doçaria tradicional brasileira. Qual é o metal utilizado na produção dos tachos?',
            answers: [
              { letter: 'A.', text: 'Prata', correct: false },
              { letter: 'B.', text: 'Cobre', correct: true },
              { letter: 'C.', text: 'Ouro', correct: false },
              { letter: 'D.', text: 'Chumbo', correct: false },
            ],
          });
        }}>
        <Image source={panSource} style={imageStyle} />
      </Pressable>

      <Pressable
        style={{
          height: PAN2_HEIGHT,
          width: 1.35714286 * PAN2_HEIGHT,
          alignSelf: 'center',
          position: 'absolute',
          bottom: BOTTOM_SECOND_FLOOR + 0.105 * HEIGHT,
          transform: [{ translateX: -0.01 * HEIGHT }],
        }}
        onPress={() => {
          handleObjectFound({
            asset: pan2Question,
            title: 'Panela',
            object: 'pan2',
            explorationText:
              'A panela de ferro é apreciada por chefs de cozinha e possui uma longa tradição na culinária. Apresenta como algumas de suas principais propriedades manter o alimento quente por bastante tempo, já que esse metal possui boa condutibilidade térmica.  O Ferro é também um elemento importante para o nosso organismo e está presente em diversos alimentos, sua carência é responsável por causar doenças, como a anemia.',

            question:
              'Esta panela é apreciada por chefs, sua principal qualidade é o metal que mantém o alimento quente por bastante tempo devido sua boa condutividade térmica. Este metal, além de compor a panela, é um importante nutriente para o organismo e sua ausência é responsável por causar doenças como a anemia. De que metal é feita esta panela?',
            answers: [
              { letter: 'A.', text: 'Estanho', correct: false },
              { letter: 'B.', text: 'Ferro', correct: true },
              { letter: 'C.', text: 'Latão', correct: false },
              { letter: 'D.', text: 'Aço Conten', correct: false },
            ],
          });
        }}>
        <Image source={pan2Source} style={imageStyle} />
      </Pressable>

      <Pressable
        style={{
          height: REFRIGERATOR_HEIGHT,
          width: 0.47439189 * REFRIGERATOR_HEIGHT,
          alignSelf: 'center',
          position: 'absolute',
          bottom: BOTTOM_SECOND_FLOOR,
          transform: [{ translateX: -0.0925 * HEIGHT }],
        }}
        onPress={() => {
          handleObjectFound({
            asset: refrigeratorQuestion,
            title: 'Geladeira',
            object: 'refrigerator',
            explorationText:
              'Ligas metálicas são materiais com propriedades metálicas formadas por dois ou mais elementos, sendo que pelo menos um deles é um metal. O Aço, por exemplo, é uma liga formada por ferro e carbono e é muito utilizada em eletrodomésticos.',
            question:
              'Uma liga metálica, formada majoritariamente por ferro e carbono, é uma das ligas mais usadas hoje em dia. Seu uso é comum em nossas casas e está presente em diversos eletrodomésticos. Que liga metálica seria essa?',
            answers: [
              { letter: 'A.', text: 'Aço', correct: true },
              { letter: 'B.', text: 'Alumínio', correct: false },
              { letter: 'C.', text: 'Ouro', correct: false },
              { letter: 'D.', text: 'Latão', correct: false },
            ],
          });
        }}>
        <Image source={refrigeratorSource} style={imageStyle} />
      </Pressable>

      <Pressable
        style={{
          height: SCULPTURE_HEIGHT,
          width: 1.38235294 * SCULPTURE_HEIGHT,
          alignSelf: 'center',
          position: 'absolute',
          bottom: BOTTOM_FIRST_FLOOR + 0.1185 * HEIGHT,
          transform: [{ translateX: -0.112 * HEIGHT }],
        }}
        onPress={() => {
          handleObjectFound({
            asset: sculptureQuestion,
            title: 'Escultura',
            object: 'sculpture',
            explorationText:
              'O bronze é uma liga metálica  composta por Cobre e Estanho com uma boa durabilidade e maleabilidade. É o metal escolhido por diversos artistas para a fabricação de estátuas.',
            question:
              'Qual liga metálica feita, sobretudo, de cobre e estanho, tornou-se um metal bastante utilizado por artistas para a confecção de bustos e estátuas?',
            answers: [
              { letter: 'A.', text: 'Bronze', correct: true },
              { letter: 'B.', text: 'Cobre', correct: false },
              { letter: 'C.', text: 'Chumbo', correct: false },
              { letter: 'D.', text: 'Nióbio', correct: false },
            ],
          });
        }}>
        <Image source={sculptureSource} style={imageStyle} />
      </Pressable>

      <Pressable
        style={{
          height: SOLAR_PANEL_HEIGHT,
          width: 2.173625 * SOLAR_PANEL_HEIGHT,
          alignSelf: 'center',
          position: 'absolute',
          bottom: BOTTOM_ROOF_TOP,
          transform: [{ translateX: 0.153 * HEIGHT }],
        }}
        onPress={() => {
          handleObjectFound({
            asset: solarPannelQuestion,
            title: 'Painel Solar',
            object: 'solarPannel',
            explorationText:
              'O principal componente dos painéis solares são as células de silício que são parte ativa desses painéis, ou seja, onde a energia elétrica é produzida. Esse componente é representado pelo símbolo “Si” na tabela periódica.',
            question:
              'O principal componente dos painéis solares são as células de __________, que é parte ativa desses painéis, ou seja, onde a energia elétrica é produzida. Esse componente é representado pelo símbolo “Si” na tabela periódica.',
            answers: [
              { letter: 'A.', text: 'Silicio', correct: true },
              { letter: 'B.', text: 'Ferro', correct: false },
              { letter: 'C.', text: 'Cobre', correct: false },
              { letter: 'D.', text: 'Magnésio', correct: false },
            ],
          });
        }}>
        <Image source={solarPannelSource} style={imageStyle} />
      </Pressable>

      <Pressable
        style={{
          height: STREET_HEIGHT,
          width: 17.1428571 * STREET_HEIGHT,
          alignSelf: 'center',
          position: 'absolute',
          bottom: 0,
          transform: [{ translateX: 0 * HEIGHT }],
        }}
        onPress={() => {
          handleObjectFound({
            asset: streetQuestion,
            title: 'Pavimento',
            object: 'street',
            explorationText:
              'As ruas de paralelepípedo tradicionais de bairros mais residenciais são feitas de granito. Seu custo é mais elevado porém requer menos manutenção, melhora a permeabilidade da água no solo e ajuda a reduzir a velocidade de veículos',
            question: 'Você sabe qual minério é utilizado para fazer as ruas de paralelepípedo?',
            answers: [
              { letter: 'A.', text: 'Mármore', correct: false },
              { letter: 'B.', text: 'Granito', correct: true },
              { letter: 'C.', text: 'Quartzo', correct: false },
              { letter: 'D.', text: 'Calcário', correct: false },
            ],
          });
        }}>
        <Image source={streetSource} style={imageStyle} />
      </Pressable>

      <Pressable
        style={{
          height: SUPPLEMENT_HEIGHT,
          width: 0.58489033 * SUPPLEMENT_HEIGHT,
          alignSelf: 'center',
          borderWidth: 1,
          position: 'absolute',
          bottom: BOTTOM_FIRST_FLOOR + 0.02 * HEIGHT,
          transform: [{ translateX: 0.057 * HEIGHT }, { scale: 3 }],
        }}
        onPress={() => {
          handleObjectFound({
            asset: supplementQuestion,
            title: 'Suplemento',
            object: 'supplement',
            explorationText:
              'Vários metais como por exemplo o Zinco e o Ferro são essenciais para a saúde e para o funcionamento do nosso organismo. Eles são encontrados nos alimentos, mas, por vezes, quando há carência desses elementos, necessitamos de suplementação.',
            question:
              'Vários metais são essenciais para a saúde e para o funcionamento do nosso organismo. Eles são encontrados nos alimentos, mas, por vezes, quando há carência desses elementos, necessitamos de suplementação. Quais são os principais elementos metálicos utilizados na indústria farmacêutica para a produção de suplementos? ',
            answers: [
              { letter: 'A.', text: 'Ferro, Zinco', correct: true },
              { letter: 'B.', text: 'Chumbo, Zinco', correct: false },
              { letter: 'C.', text: 'Paládio, Ferro', correct: false },
              { letter: 'D.', text: 'Aço, Latão', correct: false },
            ],
          });
        }}>
        <Image source={supplementSource} style={[imageStyle, { transform: [{ scale: 0.3333 }] }]} />
      </Pressable>

      <Pressable
        style={{
          height: TETRA_PACK_HEIGHT,
          width: 0.48484848 * TETRA_PACK_HEIGHT,
          alignSelf: 'center',
          position: 'absolute',
          bottom: BOTTOM_SECOND_FLOOR + 0.042 * HEIGHT,
          transform: [{ translateX: 0.136 * HEIGHT }],
        }}
        onPress={() => {
          handleObjectFound({
            asset: tetrapackQuestion,
            title: 'Caixa de leite',
            explorationText:
              'Nas embalagens Tetrapak uma pequena porcentagem de Alumínio já é capaz de proteger o alimento contra  o oxigênio e a luz bem como por manter a temperatura, conservando o alimento.',
            object: 'tetrapack',
            question:
              'Em determinados tipos de embalagens, conhecidas como Tetra Pak, o metal _________ mesmo compondo apenas 5% da embalagem é o  principal responsável por proteger contra  o oxigênio, a luz bem como por manter a temperatura para a melhor conservação do alimento.',
            answers: [
              { letter: 'A.', text: 'Aço', correct: false },
              { letter: 'B.', text: 'Alumínio', correct: true },
              { letter: 'C.', text: 'Papelão', correct: false },
              { letter: 'D.', text: 'Ferro', correct: false },
            ],
          });
        }}>
        <Image source={tetrapackSource} style={imageStyle} />
      </Pressable>

      <Pressable
        style={{
          height: TOILET_HEIGHT,
          width: 0.66257669 * TOILET_HEIGHT,
          alignSelf: 'center',
          position: 'absolute',
          bottom: BOTTOM_FIRST_FLOOR,
          transform: [{ translateX: 0.095 * HEIGHT }],
        }}
        onPress={() => {
          handleObjectFound({
            asset: toiletQuestion,
            title: 'Vaso sanitário',
            object: 'toilet',
            explorationText:
              'A cerâmica branca é utilizada na fabricação de vasos sanitários. A complexidade do molde e a baixa deformação que a porcelana apresenta na queima, são fatores que contribuem para o emprego da cerâmica na fabricação dos sanitários.',
            question: 'O material mais usado para a fabricação de vasos sanitários é o/a _________',
            answers: [
              { letter: 'A.', text: 'Concreto', correct: false },
              { letter: 'B.', text: 'Areia', correct: false },
              { letter: 'C.', text: 'Óxido de Prata', correct: false },
              { letter: 'D.', text: 'Cerâmica Branca', correct: true },
            ],
          });
        }}>
        <Image source={toiletSource} style={imageStyle} />
      </Pressable>

      <Pressable
        style={{
          height: TROPHY_HEIGHT,
          width: 0.65693431 * TROPHY_HEIGHT,
          alignSelf: 'center',
          explorationText:
            'Símbolo de riqueza, esse metal é utilizado como reserva monetária pelos bancos centrais dos países, o ouro é empregado na produção de moedas, troféus e medalhas, distribuído como prêmio aos melhores colocados de competições. Apesar de ser bastante conhecido pelo seu emprego na joalheria, também é um metal muito utilizado em indústrias de ponta como na eletrônica, no setor médico e aeroespacial.',
          position: 'absolute',
          bottom: BOTTOM_THIRD_FLOOR + 0.007 * HEIGHT,
          transform: [{ translateX: -0.098 * HEIGHT }],
        }}
        onPress={() => {
          handleObjectFound({
            asset: trophyQuestion,
            title: 'Troféu',
            object: 'trophy',
            explorationText:
              'Símbolo de riqueza é utilizado como reserva monetária pelos bancos centrais de países. Apesar de ser mais conhecido por seu uso em joalheria,  troféus e medalhas, também é utilizado na indústria eletrônica médica e aeroespacial. Que metal é este?',
            question:
              'Símbolo de riqueza e utilizado como reserva monetária pelos bancos centrais dos países, esse metal é empregado na produção de moedas, troféus e medalhas, distribuído como prêmio aos melhores colocados de competições. Apesar de ser bastante conhecido pelo seu emprego na joalheria, também é um metal muito utilizado em indústrias de ponta como na eletrônica, no setor médico e aeroespacial.\n Qual é esse metal? ',
            answers: [
              { letter: 'A.', text: 'Platina', correct: false },
              { letter: 'B.', text: 'Prata', correct: false },
              { letter: 'C.', text: 'Ouro', correct: true },
              { letter: 'D.', text: 'Titânio', correct: false },
            ],
          });
        }}>
        <Image source={trophySource} style={imageStyle} />
      </Pressable>

      <Pressable
        style={{
          height: TRUMPET_HEIGHT,
          width: 1.6696635 * TRUMPET_HEIGHT,
          alignSelf: 'center',
          position: 'absolute',
          bottom: BOTTOM_FIRST_FLOOR + 0.09 * HEIGHT,
          transform: [{ translateX: -0.034 * HEIGHT }],
        }}
        onPress={() => {
          handleObjectFound({
            asset: trumpetQuestion,
            title: 'Trompete',
            object: 'trumpet',
            explorationText:
              'O latão é uma liga formada por cobre e zinco. Ele é empregado na produção de alguns instrumentos musicais pois apresenta resistência mecânica e à corrosão. Do mesmo modo, essa liga possui, propriedades antibacterianas, fazendo com que as bactérias tenham dificuldades de se proliferar em superfícies desse metal, tornando-o adequado para a fabricação de instrumentos como trompete e saxofone.',
            question:
              'Diversos instrumentos, como trompete ou saxofone, são feitos de uma liga formada, principalmente, por cobre e zinco. Esta liga, além de propriedades antibacterianas, possui uma ótima resistência mecânica à corrosão. Qual o nome desta liga metálica?',
            answers: [
              { letter: 'A.', text: 'Ferro Fundido', correct: false },
              { letter: 'B.', text: 'Latão', correct: true },
              { letter: 'C.', text: 'Cobre', correct: false },
              { letter: 'D.', text: 'Prata', correct: false },
            ],
          });
        }}>
        <Image source={trumpetSource} style={imageStyle} />
      </Pressable>

      <Pressable
        style={{
          height: VASE_HEIGHT,
          width: 0.39666667 * VASE_HEIGHT,
          alignSelf: 'center',
          position: 'absolute',
          bottom: BOTTOM_FIRST_FLOOR,
          transform: [{ translateX: 0.0015 * HEIGHT }],
        }}
        onPress={() => {
          handleObjectFound({
            asset: vaseQuestion,
            title: 'Vaso',
            object: 'vase',
            explorationText:
              'A cerâmica possui uma  história antiga . As peças cerâmicas são um dos achados mais comuns  durante escavações em sítios arqueológicos. Os materiais cerâmicos apresentam grande resistência mecânica e durabilidade que  contribuem para sua conservação diante de intempéries.',
            question:
              'Qual o material/técnica  utilizado para a fabricação de vasos de plantas ornamentais? Esse material é empregado desde a antiguidade e possui como característica alta dureza e elevada resistência mecânica, mesmo em altas temperaturas. ',
            answers: [
              { letter: 'A.', text: 'Areia Compactada', correct: false },
              { letter: 'B.', text: 'Barro queimado', correct: true },
              { letter: 'C.', text: 'Argila com palha', correct: false },
              { letter: 'D.', text: 'Argila desidratada e polida', correct: false },
            ],
          });
        }}>
        <Image source={vaseSource} style={imageStyle} />
      </Pressable>

      <Pressable
        style={{
          height: WATER_FILTER_HEIGHT,
          width: 0.52690426 * WATER_FILTER_HEIGHT,
          alignSelf: 'center',
          position: 'absolute',
          bottom: BOTTOM_ZERO_FLOOR + 0.0635 * HEIGHT,
          transform: [{ translateX: -0.01 * HEIGHT }],
        }}
        onPress={() => {
          handleObjectFound({
            asset: waterFilterQuestion,
            title: 'Filtro de barro',
            object: 'waterFilter',
            explorationText:
              'Os filtros de barro (moringa) são populares nas casas brasileiras, eles filtram impurezas e ajudam a manter a temperatura da água. Tanto a vela que filtra a água quanto a estrutura da moringa são feitas de cerâmica.',
            question:
              'Os filtros de barro (moringa) são populares nas casas brasileiras, eles filtram impurezas e ajudam a manter a temperatura da água. A vela que filtra a água e a estrutura da moringa são feitos de:',
            answers: [
              { letter: 'A.', text: 'Plástico', correct: false },
              { letter: 'B.', text: 'Ferro', correct: false },
              { letter: 'C.', text: 'Areia Compactada', correct: false },
              { letter: 'D.', text: 'Cerâmica', correct: true },
            ],
          });
        }}>
        <Image source={waterFilterSource} style={imageStyle} />
      </Pressable>
      <Pressable
        style={{
          height: CHALICE_HEIGHT,

          width: 0.8421 * CHALICE_HEIGHT,
          alignSelf: 'center',

          position: 'absolute',
          bottom: BOTTOM_ZERO_FLOOR,
          transform: [{ translateX: -0.09 * HEIGHT }, { translateY: -0.0639 * HEIGHT }],
        }}
        onPress={() => {
          handleObjectFound({
            asset: chaliceQuestion,
            explorationText:
              'O ouro teve um papel importante na História do Brasil durante o século XVII/XVIII, conferindo grande visibilidade à região de Minas Gerais e sendo encontrado na arquitetura e objetos religiosos das igrejas mineiras.',
            title: 'Cálice',
            object: 'chalice',
            question:
              'Esse metal teve um papel importante na História do Brasil durante o século XVII/XVIII, conferindo grande visibilidade à região de Minas Gerais e sendo encontrado na arquitetura das igrejas mineiras. Qual é esse metal? ',
            answers: [
              { letter: 'A.', text: 'Ferro', correct: false },
              { letter: 'B.', text: 'Bronze', correct: false },
              { letter: 'C.', text: 'Cobre', correct: false },
              { letter: 'D.', text: 'Ouro', correct: true },
            ],
          });
        }}>
        <Image source={chaliceSource} style={imageStyle} />
      </Pressable>

      <Pressable
        style={{
          height: FRAME_HEIGHT,

          width: 1.35135 * FRAME_HEIGHT,
          alignSelf: 'center',

          position: 'absolute',
          bottom: BOTTOM_THIRD_FLOOR,
          transform: [{ translateX: -0.051 * HEIGHT }, { translateY: -0.112 * HEIGHT }],
        }}
        onPress={() => {
          handleObjectFound({
            asset: frameQuestion,
            explorationText:
              'A prata por ser fotossensível é empregado na produção de imagens fotográficas analógicas. Possui inúmeras aplicações, embora seja mais conhecido por seu emprego no setor joalheiro',
            title: 'Fotografia',
            object: 'frame',
            question:
              'Por ser fotossensível, esse metal é também empregado na produção de imagens fotográficas analógicas. Possui inúmeras aplicações, embora seja mais conhecido por seu emprego no setor joalheiro. Que metal é esse?',
            answers: [
              { letter: 'A.', text: 'Latão', correct: false },
              { letter: 'B.', text: 'Cobre', correct: false },
              { letter: 'C.', text: 'Ferro', correct: false },
              { letter: 'D.', text: 'Prata', correct: true },
            ],
          });
        }}>
        <Image source={frameSource} style={imageStyle} />
      </Pressable>
    </>
  );
};

export default ObjectsPositioning;
